import { useQuery } from '@tanstack/react-query';
import { getFolderTypes } from '../../api/edms/lookups';

function getFolderTypesList(response) {
  if (!response) return [];
  const d = response.data ?? response;
  if (Array.isArray(d?.folderTypes)) return d.folderTypes;
  if (Array.isArray(d)) return d;
  return [];
}

export const useActiveFolderTypes = (options = {}) => {
  const query = useQuery({
    queryKey: ['edms', 'folderTypes', 'active'],
    queryFn: () => getFolderTypes({ isActive: true }),
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    folderTypes: getFolderTypesList(query.data),
  };
};

export default useActiveFolderTypes;
